// Module
var code = "<!-- ko if: matches -->\n<!-- ko template: { nodes: $componentTemplateNodes } -->\n<!-- /ko -->\n<!-- /ko -->\n";
// Exports
module.exports = code;